<app-rad-base-modal #radBaseModal
    [identifier]="modalType"
    [title]="ngxSmartModalTitle"
    [disableConfirmButton]="disableConfirmButton"
    closable="true"
    showCloseButton="true" 
    [closeButtonText]="closeButtonText"
    [confirmButtonText]="confirmButtonText"
    contentMarginTop="0px">

    <app-rad-edit-info
        [editableFields]="fields"
        (confirm)="dataChanged($event)"
        [errorMsg]="errorMsg?.toString()">
    </app-rad-edit-info>

</app-rad-base-modal>

